import React, { createContext, useContext } from "react";

export interface SchemaEditorLayoutActions {
  openJsonEditor: () => void;
}

const SchemaEditorLayoutContext = createContext<SchemaEditorLayoutActions | null>(null);

export const SchemaEditorLayoutProvider = ({
  value,
  children,
}: {
  value: SchemaEditorLayoutActions;
  children: React.ReactNode;
}) => (
  <SchemaEditorLayoutContext.Provider value={value}>{children}</SchemaEditorLayoutContext.Provider>
);

export const useSchemaEditorLayout = (): SchemaEditorLayoutActions => {
  const context = useContext(SchemaEditorLayoutContext);
  if (!context) {
    throw new Error("useSchemaEditorLayout must be used within SchemaEditorLayoutProvider");
  }
  return context;
};

export const useSchemaEditorLayoutOptional = (): SchemaEditorLayoutActions | null =>
  useContext(SchemaEditorLayoutContext);
